import { ETheme } from '../repositories/mortgage-broker-calculator/entities/mortgage_listing/ListingButton';
import { TButtonTheme } from '@cian/ui-kit/button/types';

export const mapThemBtn: Record<ETheme, TButtonTheme> = {
  trigger: 'fill_secondary',
  default: 'fill_secondary',
};
